.inputContainer {
	display: flex;
  flex-direction: row;
	align-items: center;
  justify-content: space-between;
	height: 100%;
  width: 100%;
}

.signInContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.execAssociationForm {
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  gap: 15px;
}

.execAssociationFormCtrl {
  flex: 1;
  max-width: 300px;
  margin: 10px;
}

.emailFormCtrl {
  width: 100%;
  margin: 10px;
  margin-top: -15px;
  margin-left: 0px;
  margin-bottom: 15px;
}

.outerGrid {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.alternateHosts {
  padding-top: 0px;
  width: 100%;
}

.execButtons {
  flex: 1;
}

.signInButton {
  width: 180px;
  height: auto;
  box-shadow: 0px 0px 3px gray;
}

.altHostsContainer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.altHostsSpinner {
  display: flex;
  justify-content: center;
}

.conferenceDescription {
  font-size: 15px;
  margin-bottom: 24px;
}

.pmiExplainer {
  font-size: 15px;
  margin-bottom: 36px;
}

.execName {
  min-width: 75px;
}

.pmiLabel {
  margin: 0;
  margin-right: 0px;
}

.zoomExecSettingsContainer {
  width: 100%;
}

.divider {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
}

.execSettingsForm {
  width: 100%;
}

.saveExecsButton {
  width: auto;
  height: 36px;
}
.sharedAccessPermissionImg {
  margin-top: 20px;
  margin-bottom: 20px;
}

.connectText {
  margin-right: 25px;
}